<template>
  <b-col>
    <chromatography-flex-table-title
      :method="data.method"
      :norm="norm"
      :hasAlarms="data.alarmed"
      :executed="data.executed"
    />
    <b-table-simple class="not-executed-print-table" bordered outlined small caption-top>
      <b-thead>
        <b-tr class="not-executed-print-table__row-no-border-bottom">
          <b-th>
            <div>{{$t('engineering.reports.test')}}</div>
          </b-th>
          <b-th>
            <div>{{ translate('sample-gas-percentage') }}</div>
          </b-th>
          <b-th>
            <div>
              {{
                $t('fields.engineering.chromatography.limit-for-analytical-accuracy-abbreviation')
              }}
            </div>
          </b-th>
          <b-th class="text-center">
            <div>{{ $t('engineering.report') }}</div>
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="(gas, index) in data.data.gas"
          :key="gas.gas"
          class="not-executed-print-table__row-no-border-top"
        >
          <b-td class="not-executed-print-table__column-name">
            <gas-label :value="transformGasValue(gas.gas)" />
          </b-td>
          <b-td class="not-executed-print-table__column-value text-center">
            <div>-</div>
          </b-td>
          <b-td class="not-executed-print-table__column-aal text-center">
            {{ $n(gas.aal) }}
          </b-td>
          <b-td
            class="not-executed-print-table__column-diagnostic text-center"
            v-if="index === 0"
            :rowspan="data.data.gas.length - 1"
          >
            <div class="not-executed-print-table__display-print">
              {{ notExecutedReason }}
            </div>
          </b-td>
          <b-td
            class="not-executed-print-table__column-multiplier text-left"
            v-if="index === data.data.gas.length - 1"
          >
            <div class="not-executed-print-table__display-print">
              {{ $t('fields.engineering.chromatography.multiplier') }}: {{data.data.multiplier}}
            </div>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </b-col>
</template>

<script>
import ChromatographyFlexTableTitle from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/individualAnalysis/ChromatographyFlexTableTitle';
import { Rules } from 'sigma-mappings';
import GasLabel from '../../cardContents/common/GasLabel';

export default {
  name: 'NotExecutedPrint',
  components: {
    ChromatographyFlexTableTitle,
    GasLabel,
  },
  props: {
    data: Object,
    norm: String,
  },
  computed: {
    notExecutedReason() {
      const hasReason = this.data.data.reason && this.data.data.reason.code;
      if (hasReason && this.norm === Rules.DUVAL) {
        const { messageCode, algorithm } = this.getDuvalMessageCodeAndParam();
        return this.$t(`messages.${messageCode}.message`, { 0: algorithm });
      }
      return this.notExecutedDefaultMessage;
    },
    notExecutedDefaultMessage() {
      return this.$t('engineering.chromatography.methods-and-diagnostics.individual-analysis.not-executed.message');
    },
  },
  methods: {
    getDuvalMessageCodeAndParam() {
      const reason = this.data.data.reason || {};
      const messageCode = reason.code;
      const messageParameters = reason.parameters || [];
      const algorithm = this.$t(`engineering.chromatography.method-parameters.${messageParameters[0]}`);
      return { messageCode, algorithm };
    },
    translate(key) {
      const base = 'engineering.chromatography.methods-and-diagnostics.individual-analysis.print';
      return this.$t(`${base}.${key}`);
    },
    transformGasValue(gasValue) {
      return gasValue.toLowerCase();
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .table-bordered th, .table-bordered td
    border: 1px solid $color-gray-intermediary !important

  .not-executed-print-table
    ::v-deep tbody th
      background-color: var(--color-table-header-bg) !important
    ::v-deep tbody tr:first-child td
      border-top: none !important
    &__row
      &-no-border-top td
        border-top: 0 !important
      &-no-border-bottom th
        border-bottom: 0 !important
    &__column-name
      width: 20%
    &__column-aal
      width: 10%
    &__column-value
      width: 10%
    &__column-multiplier
      border-top: 0 !important
      padding-left: 15px
  .table-bordered td.not-executed-print-table__column-diagnostic
      border-bottom: 0 !important
  @media print
    .not-executed-print-table
      &__display-print
        display: block
        float: none

</style>
